var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8333H10.8333V15C10.8333 15.4583 10.4583 15.8333 9.99999 15.8333C9.54166 15.8333 9.16666 15.4583 9.16666 15V10.8333H4.99999C4.54166 10.8333 4.16666 10.4583 4.16666 9.99996C4.16666 9.54163 4.54166 9.16663 4.99999 9.16663H9.16666V4.99996C9.16666 4.54163 9.54166 4.16663 9.99999 4.16663C10.4583 4.16663 10.8333 4.54163 10.8333 4.99996V9.16663H15C15.4583 9.16663 15.8333 9.54163 15.8333 9.99996C15.8333 10.4583 15.4583 10.8333 15 10.8333Z",
    fill: "#136162"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.504936466b3a638247f96d50ff40c10a.svg";
export { ForwardRef as ReactComponent };